import { defineStore } from 'pinia';

const UPDATE_INTERVAL = 60 * 1000; // 1 min.

function downtimeNow(downtime: Downtime) {
  const convertedStartDate = new Date(downtime.startDate);
  const convertedEndDate = new Date(downtime.endDate);
  const timestamp = new Date(downtime.startDate).getTime() / 1000;
  const isDate = timestamp && timestamp > 0 && !Number.isNaN(downtime.startDate);
  if (!isDate) return undefined;

  const dateNow = new Date(Date.now());

  return convertedStartDate < dateNow && convertedEndDate > dateNow;
}

export interface DowntimesState {
  downtimes: Downtime[];
  lastUpdated: number;
}

export const useDowntimesStore = defineStore('downtimes', {
  state: (): DowntimesState => ({
    downtimes: [],
    lastUpdated: 0,
  }),

  getters: {
    maintenanceDowntime(state): Downtime | undefined {
      return (state.downtimes || []).find(
        (dt: Downtime) => dt.systems.includes('maintenance') && downtimeNow(dt)
      );
    },
  },

  actions: {
    setDowntimes(downtimes: Downtime[]) {
      if (downtimes && Array.isArray(downtimes)) {
        this.downtimes = downtimes;
      } else {
        this.downtimes = [];
      }
    },

    setLastUpdated() {
      this.lastUpdated = Date.now();
    },

    async fetchDowntimes() {
      if (this.lastUpdated + UPDATE_INTERVAL > Date.now()) return;
      try {
        // do not run query twice!
        this.setLastUpdated();
        const config = useRuntimeConfig();

        const host =
          config.public.cloudFront.downtimesEnabled && config.app.cdnURL ? config.app.cdnURL : '';

        const downtimes = await $fetch<{ downtimes: Downtime[] | undefined }>(
          `${host}/api/downtimes`
        );
        this.setDowntimes(downtimes?.downtimes || []);
      } catch (error) {
        console.error(error);
      } finally {
        this.setLastUpdated();
      }
    },
  },
});
